module.exports = __webpack_public_path__ + "media/tph/icoImportant-01d53b1f.webp";